__turbopack_context__.v({
  "control": "Carousel-module__zkv5ya__control",
  "controls": "Carousel-module__zkv5ya__controls",
  "indicator": "Carousel-module__zkv5ya__indicator",
  "indicators": "Carousel-module__zkv5ya__indicators",
});
